import { createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "intro" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"goingUp\"><i class=\"icon-arrow-up2\"></i></div><div class=\"bg-intro\" id=\"home\"><div class=\"intro-cell\"><h1 class=\"\">The <strong>Future</strong> is Mobile</h1></div><a href=\"#portfolio\" class=\"continue\"><i class=\"icon-chevron-thin-right\"></i></a></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}